import { Close } from '@project-lary/react-material-symbols';
import IconComponent from 'gcs-common/components/Icon/Icon';
import Spinner from 'gcs-common/components/Spinner/Spinner';
import { ICON, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import SearchBar from 'gcs-common/design-system/ui/search-bar';
import { SidebarContent, SidebarHeader } from 'gcs-common/design-system/ui/sidebar';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import {
  getMessageSearchErrorMessage,
  getMessageSearchInput,
  getMessageSearchIsLoading,
  getMessageSearchResults,
} from 'gcs-common/slices/messageSearch/messageSearchSelectors';
import { setMessageSearchInput } from 'gcs-common/slices/messageSearch/messageSearchSlice';
import { searchChannelMessages } from 'gcs-common/slices/messageSearch/messageSearchThunks';
import { getChannelOldestLoadedMessage } from 'gcs-common/slices/messages/messagesSelectors';
import { setRightBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SearchResultMessage } from '../SearchResultMessage/SearchResultMessage';
import styles from './styles.module.scss';

const MIN_INPUT_LENGTH = 3;

const Search = () => {
  const selectedChannelId = useSelector(getSelectedChannelId);
  const searchInput = useSelector(getMessageSearchInput);
  const searchLoading = useSelector(getMessageSearchIsLoading);
  const searchResultMessageIds = useSelector(getMessageSearchResults);
  const channelOldestMessage = useSelector(getChannelOldestLoadedMessage(selectedChannelId));
  const messageSearchIsLoading = useSelector(getMessageSearchIsLoading);
  const messageSearchErrorMessage = useSelector(getMessageSearchErrorMessage);
  const dispatch = useDispatch();

  const shouldSearch = searchInput.length >= MIN_INPUT_LENGTH;

  const onClose = useCallback(() => {
    dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.TOOLS }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(setMessageSearchInput({ searchInput: '' }));
  }, [dispatch, selectedChannelId]);
  useEffect(() => {
    if (shouldSearch) {
      dispatch(
        searchChannelMessages({
          channelId: selectedChannelId,
          searchString: searchInput,
        }),
      );
    }
  }, [dispatch, searchInput, selectedChannelId, shouldSearch, channelOldestMessage]);

  const onInputChange = (value) => {
    dispatch(setMessageSearchInput({ searchInput: value }));
  };

  let results = null;

  if (searchInput.length === 0) {
    results = <div className={styles.noResult}>Gib oben einen Suchbegriff ein.</div>;
  } else if (!shouldSearch) {
    results = (
      <div className={styles.noResult}>Bitte gebe drei oder mehr Zeichen ein, um mit der Suche zu beginnen</div>
    );
  } else if (searchLoading) {
    results = (
      <div className={styles.noResult}>
        <Spinner size={ICON_SIZE.XX_SMALL} />
        &nbsp; Suche...
      </div>
    );
  } else if (searchResultMessageIds.length === 0) {
    results = <div className={styles.noResult}>Keine Ergebnisse gefunden</div>;
  } else {
    // render messages
    results = (
      <>
        {messageSearchIsLoading && (
          <div className={styles.noResult}>
            <Spinner size={ICON_SIZE.XX_SMALL} />
            &nbsp; Suche...
          </div>
        )}
        {searchResultMessageIds.map((messageId) => {
          return <SearchResultMessage key={messageId} messageId={messageId} />;
        })}
      </>
    );
  }

  return (
    <div className={styles.searchList}>
      <SidebarHeader>
        <div className="flex-1" />
        <div className="text-center text-base">Suche</div>
        <div className="flex flex-1 justify-end">
          <button onClick={onClose} type="button">
            <IconButton Icon={Close} iconSize="size-6" className="cursor-pointer" size="m" variant="ghost_neutral" />
          </button>
        </div>
      </SidebarHeader>
      <SidebarContent className="p-4">
        <SearchBar onSearchText={onInputChange} placeholderText="Suchwort" value={searchInput} />
        {messageSearchErrorMessage && (
          <div className={styles.errorMsg}>
            Es ist ein Fehler aufgetreten. &nbsp;Möglicherweise konnten nicht alle Suchergebnisse geladen werden.
          </div>
        )}
        <div className={styles.searchResultList}>{results}</div>
      </SidebarContent>
    </div>
  );
};

Search.propTypes = {};

export default Search;
